import { AdvisorForm, AdvisorHistory, AdvisorResponse } from '@/types/advisor';
import { getSubmitAdvisorHistory, submitAdvisorHistory } from '../trnSubmitAdvisorHistory';

export const getSubmitAdvisorHistoryService = async () => {
    let careerInfo: AdvisorHistory[] = [];
    const res = await getSubmitAdvisorHistory();
    if (res.data.detail != null) {
        careerInfo = res.data.detail;
    }
    return careerInfo;
};

export const submitAdvisorHistoryService = async (form: AdvisorForm) => {

    let response: AdvisorResponse = {} as AdvisorResponse;
    const res = await submitAdvisorHistory(form);
    if (res.data != null) {
        response = res.data;
    }
    return response;
};